import React from "react";
import { projectsData } from "../projectsData";
import { projectInquiryUrl } from "../lib/contact";
import Project from "./project";
import FeasibilityBot from "./feasibilityBot";
import ContactBand, { FactsRow } from "./contactBand";

const Home = () => {
  const services = [
    {
      title: "Native iOS apps",
      text: "SwiftUI product work for polished, App Store-ready experiences.",
    },
    {
      title: "Cross-platform apps",
      text: "React Native, Expo, Flutter, and KMP — speed without losing craft.",
    },
    {
      title: "MVP to production",
      text: "A rough idea or prototype into a stable app people can use.",
    },
    {
      title: "App architecture & design",
      text: "Scalable architecture, clean module boundaries, and technical foundations that hold up as the app grows.",
    },
  ];

  const featured = projectsData.filter((project) => project.tier === "featured");
  const selected = projectsData.filter((project) => project.tier === "selected");
  const archive = projectsData.filter((project) => project.tier === "archive");

  const renderProject = (project, index, options = {}) => (
    <Project
      key={project.title}
      title={project.title}
      description={project.description}
      imageUrls={project.imageUrls}
      link={project.link}
      date={project.date}
      techStack={project.techStack}
      status={project.status}
      showcase={project.showcase}
      logo={project.logo}
      appStoreUrl={project.appStoreUrl}
      featured={options.featured}
      wide={project.layout === "wide"}
      index={index}
    />
  );

  return (
    <main className="home-page">
      <section className="home-hero">
        <h1 className="home-title">
          Production-ready apps, <em>from idea to launch.</em>
        </h1>
        <p className="home-intro">
          Native and cross-platform app developer since 2014. I build complex
          production mobile apps — and personal projects that feel calm, fast,
          and a little playful.
        </p>
        <div className="hero-actions">
          <a
            className="button-link"
            href={projectInquiryUrl}
          >
            Start a mobile app project
          </a>
          <FeasibilityBot />
        </div>
        <FactsRow />
      </section>

      <section className="services-section" aria-labelledby="services-title">
        <div className="rule-head">
          <span className="rule-idx">01</span>
          <h2 id="services-title">How I can help</h2>
          <p>
            Founders, small teams, and product owners who need a senior mobile
            engineer.
          </p>
        </div>
        <div className="services-strip">
          {services.map((service) => (
            <article className="service-cell" key={service.title}>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </article>
          ))}
        </div>
      </section>


      <section className="work-section" aria-labelledby="projects-title">
        <div className="rule-head">
          <span className="rule-idx">02</span>
          <h2 id="projects-title">Selected work</h2>
          <p>Apps I designed, built, and shipped end to end.</p>
        </div>
        <div className="project-list">
          {featured.map((project, index) =>
            renderProject(project, index, { featured: true })
          )}
          {selected.map((project, index) =>
            renderProject(project, index + featured.length)
          )}
        </div>

        <h3 className="archive-title" id="archive-title">
          Earlier experiments
        </h3>
        <ul className="archive-list" aria-labelledby="archive-title">
          {archive.map((project) => (
            <li className="archive-row" key={project.title}>
              <span className="archive-year">{project.date}</span>
              <span className="archive-name">
                {project.link ? (
                  <a
                    href={project.link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {project.title}
                  </a>
                ) : (
                  project.title
                )}
              </span>
              <span className="archive-desc">{project.description}</span>
              <span className="archive-stack">
                {project.techStack.join(" · ")}
              </span>
            </li>
          ))}
        </ul>
      </section>


      <ContactBand />
    </main>
  );
};

export default Home;
